/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Presentation = createReactComponent("presentation", "Presentation", [["path", { "d": "M3 4h18m-1.9 0v9.778c0 .471-.19.923-.527 1.257-.338.333-.796.52-1.273.52H6.7c-.477 0-.935-.187-1.273-.52a1.767 1.767 0 0 1-.527-1.257V4m2.6 16 4.5-4.444L16.5 20", "key": "svg-0" }]]);

export { Presentation as default };
//# sourceMappingURL=Presentation.js.map
